import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator that requires at least one of the specified fields to have a value
 * @param fields - Array of field names to check
 * @returns Validator function
 */
export function atLeastOneValidator(fields: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const hasAtLeastOne = fields.some(fieldName => {
      const field = control.get(fieldName);
      return field && field.value !== null && field.value !== undefined && field.value !== '';
    });

    return hasAtLeastOne ? null : { atLeastOneRequired: { fields } };
  };
}

